import moment from 'moment';

import { OnSchedRest }    from '../../OnSchedRest';
import OnSchedResponse    from '../../OnSchedResponse';
import { OnSchedHelpers } from '../../utils/OnSchedHelpers';
import { OnSchedOnClick } from '../../utils/OnSchedOnClick'
import { OnSchedTemplates } from '../../OnSchedTemplates';

export const AppointmentsList = (element, response) => {
  var eventModel;
  var getAppointmentsEvent;
  if (response.error || response.count === 0) {
      eventModel = { message: 'No appointments found matching search input.' };
      getAppointmentsEvent = new CustomEvent("notFound", { detail: eventModel });
      var el = document.getElementById(element.id);
      el.dispatchEvent(getAppointmentsEvent);
      return;
  }
  var htmlAppointments = OnSchedTemplates.appointmentsList(response);
  var el = document.getElementById(element.id);
  el.innerHTML = htmlAppointments;
}

export const CreateAppointment = (element, response) => {
  if (response.error) {
    let toastErrorData = response;
    if (response.data.errors.filter(e => e.code === 'BOOKING-105')?.length) {
      toastErrorData = {
        error: true,
        data: {
          errors: [{ status: 'Error', error: 'Sorry, that appointment has since been taken. Please select a new time.' }]
        }
      }

      // Refresh the list of times now
      const timezoneName = moment.tz.guess();
      var elTimezone = document.getElementById('onsched-timezone');
      var el = document.getElementById(element.id);
      
      var url = OnSchedHelpers.CreateAvailabilityUrl(element.onsched.apiBaseUrl, element.params, element.params.date, timezoneName);
    
      // calculate available days to pull when mounting
      url = OnSchedHelpers.AddUrlParam(url, "dayAvailabilityStartDate",
          OnSchedHelpers.CreateDateString(OnSchedHelpers.GetFirstCalendarDate(element.params.date)));
      url = OnSchedHelpers.AddUrlParam(url, "dayAvailability", 100);
      url = OnSchedHelpers.AddUrlParam(url, "firstDayAvailable", "true");
      // add additional parameters
      if (element.params.interval) url = OnSchedHelpers.AddUrlParam(url, "interval", element.params.interval);
    
      OnSchedRest.Get(url, function (response) {
        let detail = response;
        elTimezone.classList.toggle('loading');
    
        el.dispatchEvent(new CustomEvent("getAvailability", { detail }));
        OnSchedResponse.GetAvailability(element, response);
    
        var elTzList = document.getElementById('onsched-timezone-options');
        var elTzSearch = document.getElementById('onsched-timezone-search-input');
        var elTzOptions = document.querySelectorAll('.onsched-timezone-options .onsched-timezone-option');
      
        elTzOptions.forEach(option => option.onclick = e => OnSchedOnChange.OnChangeTimezone(e, element, response));
        
        elTzSearch.onkeyup = e => {
          elTzList.innerHTML = '';
      
          [...elTzOptions].filter(opt => opt.innerText.toLowerCase().includes(e.target.value.toLowerCase()))
                          .forEach(opt => elTzList.appendChild(opt))
        }  
      })
    }

    OnSchedHelpers.ThrowError(element, toastErrorData)
  }
  else {
    const { completeBooking, customerId } = element.params;
  
    let bookingForm = true;
    
    if (completeBooking) {
        if (completeBooking === 'IN') {
            // If completeBooking is IN or RS, POST the appointment
            bookingForm = false;
        }
        else {
            // If completeBooking is BK or RS, require a customerId to complete the booking
          if (customerId) {
              bookingForm = false;
          }
        }
    }
  
  
    // POST appointment now supports two flows
    // 1. Render a booking form, then do a PUT operation to complete later
    // 2. Complete the booking with the information supplied
    if (bookingForm) {
        // Flow 1 - render the booking flow
        // Render the booking form here
        
        const url = `${element.onsched.setupApiBaseUrl}/locations${element.params.locationId ? '/' + element.params.locationId : ''}`
        
        // GET the location to display booking timer minutes
        OnSchedRest.Get(url, locationsResponse => {
          var timerMins = 2;
          // Check which location's timer to use
          if(locationsResponse.object === 'business') {
            // Location ID not provided, check primary business bookingTimer
            timerMins = locationsResponse.data.filter(l => l.primaryBusiness === true)[0].settings.bookingTimerMins;
          }
          else if (locationsResponse.object === 'location') {
            // Location ID provided, use booking timer mins
            timerMins = locationsResponse.settings.bookingTimerMins;
          }
  
          var elBookingFormContainer = document.querySelector(".onsched-booking-form-container");
          elBookingFormContainer.innerHTML = OnSchedTemplates.bookingForm(response, element.options, element.onsched.locale, timerMins);
          
          OnSchedHelpers.StartBookingTimer("#onsched-popup-booking-timer-container", timerMins, () => OnSchedOnClick.BookingFormCancel(element));
          
          var elPopup = document.querySelector(".onsched-popup-shadow");
          elPopup.classList.add("is-visible");
    
          var elFormShadow = document.querySelector(".onsched-popup-shadow.is-visible");
          elFormShadow.addEventListener("click", function (event) {
              if (event.target.classList.contains("onsched-close-btn") ||
                  event.target.classList.contains("onsched-popup-shadow") ||
                  event.target.classList.contains("btn-cancel")) {
                  OnSchedOnClick.BookingFormCancel(element);
              }
          });
    
          var elAvailability = document.getElementById('availability');
          var elPopupForm = document.querySelector('.onsched-popup');
    
          OnSchedHelpers.RepositionModal(elAvailability, '.onsched-popup-shadow', '.onsched-popup');
    
          let animation = [
            { height: '0px' },
            { height: elAvailability.clientHeight + 'px' }
          ]
          
          if (elAvailability.clientWidth >= 992) {
            animation = [
                { width: '0px' },
                { width: elAvailability.clientWidth + 'px' }
            ]
          }
    
          elPopupForm.animate(animation, {
            // timing options
            duration: 300,
            delay: 0,
            iterations: 1,
            fill: 'forwards'
          });
    
          var elBookingForm = document.querySelector(".onsched-form.booking-form");
          elBookingForm.addEventListener("keyup", e => {
              // if we press the ESC
              if (e.key == "Escape") {
                  OnSchedOnClick.BookingFormCancel(element);
              }
          });
          elBookingForm.addEventListener("submit", function (e) {
              e.preventDefault(); // before the code
              OnSchedOnClick.BookingFormSubmit(e, element);
          });
        })
    }
    else {
        // Flow 2 - completed booking with information supplied
        // Fire event to the element to notify of booking complete
        var elAvailability = document.getElementById(element.id);
        var bookingConfirmationEvent = new CustomEvent("bookingConfirmation", { detail: response });
        elAvailability.dispatchEvent(bookingConfirmationEvent);
    }
  }
}

export const BookAppointment = (element, response) => {
    var elCloseBtn = document.querySelector(".onsched-close-btn");

    clearInterval(element.timerId);
    if (response.error) {
      OnSchedHelpers.ThrowError(element, response);
        if (response.validation) {
            var errorBoxParams = { code: response.code, message: response.data.error };
            var errorContainer = document.querySelector(".onsched-error-container");
            errorContainer.innerHTML = OnSchedTemplates.errorBox(errorBoxParams);
            elCloseBtn.click(); // simulate click of close button
        }
        else {
          elCloseBtn.click(); // simulate click of close button
        }
    }
    else {
        document.querySelector(".onsched-popup-shadow").classList.remove("is-visible");

        // clear out the availbility container
        var elAvailabilityContainer = document.querySelector(".onsched-container.onsched-availability")
        elAvailabilityContainer.innerHTML = "";

        // Need logic here to check if overriding the bookingConfirmation.

        if (element.options.bookingConfirmation != null && element.options.bookingConfirmation.suppressUI) {
            console.log("Suppress UI in BookingConfirmation")
        }
        else {
            var bookingConfirmationHtml = OnSchedTemplates.confirmation(response);
            var elBookingConfirmationContainer = document.querySelector(".onsched-booking-confirmation-container");
            elBookingConfirmationContainer.innerHTML = bookingConfirmationHtml;    
        }

        // fire client event to inform of bookingConfirmation with response data
        var elAvailability = document.getElementById(element.id);
        var bookingConfirmationEvent = new CustomEvent("bookingConfirmation", { detail: response });
        elAvailability.dispatchEvent(bookingConfirmationEvent);
    }
}

export const RescheduleAppointment = (element, response) => {
  const elAvailabilityContainer = document.querySelector(".onsched-container.onsched-availability")
  const elBookingConfirmationContainer = document.querySelector(".onsched-booking-confirmation-container");
  const elAvailability = document.getElementById(element.id);

  if (response.error) {
    // If 
    const msg = 'This appointment has already been rescheduled.';
    const reformattedResponse = OnSchedHelpers.ReformatErrorMsg(response, 'BOOKING-126', msg);

    OnSchedHelpers.ThrowError(element, reformattedResponse);
  }
  else {
    // Clear out the availbility container
    elAvailabilityContainer.innerHTML = "";
    
    // Set confirmation
    let bookingConfirmationHtml = OnSchedTemplates.rescheduleConfirmation(response);
    elBookingConfirmationContainer.innerHTML = bookingConfirmationHtml;        
  }

  // Trigger confirmation event
  let bookingConfirmationEvent = new CustomEvent("rescheduleConfirmation", { detail: response });
  elAvailability.dispatchEvent(bookingConfirmationEvent);
}
